import React from "react";
import usePersistedState from "../../hooks/usePersistedState";

function useCollapsePriceSelector() {
  const [openPI, setOpenPI] = usePersistedState("openPI", false);

  const handleOpen = () => setOpenPI(true);
  const handleClose = () => setOpenPI(false);

  return {
    handleClose,
    handleOpen,
    openPI,
  };
}

export default useCollapsePriceSelector;
